/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconShieldShare = createReactComponent("shield-share", "IconShieldShare", [
  [
    "path",
    {
      d: "M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .193 6.025",
      key: "svg-0"
    }
  ],
  ["path", { d: "M16 22l5 -5", key: "svg-1" }],
  ["path", { d: "M21 21.5v-4.5h-4.5", key: "svg-2" }]
]);

export { IconShieldShare as default };
//# sourceMappingURL=IconShieldShare.js.map
